import { isAxiosError } from "axios";
import inovaone_api from "./inovaone_api";
import {
  dividirEmLotes,
  MAX_ITENS_POR_LOTE_INOVAID,
  type ItemInovaid,
} from "@/lib/destinoItens";

// Envio dos itens impressos para o destino externo da configuração de
// impressão (iNOVAID ou URL personalizada). O navegador não tem os tokens: a
// API do iNOVAONE lê a configuração e repassa com o token salvo
// (POST /impressao_config/:_id/destino_itens/itens e .../tags).

export type RespostaCriarItensDestino = {
  criados: { _id?: string; tag: string; nome?: string }[];
  existentes: { _id?: string; tag: string; nome?: string }[];
  recusados: { indice?: number; tag: string; motivo?: string }[];
};

/** Mensagem legível do erro devolvido pela API (campo "mensagem"). */
export function mensagemDoErroDeDestino(error: unknown, padrao: string) {
  if (isAxiosError(error)) {
    const mensagem = (error.response?.data as { mensagem?: string } | undefined)
      ?.mensagem;
    if (mensagem) return mensagem;
  }
  return padrao;
}

function exigirConfig(id_config?: string) {
  if (!id_config) {
    throw new Error("Configuração de impressão não carregada.");
  }
  return id_config;
}

// Tags que já existem no destino (a URL personalizada não tem consulta e
// devolve lista vazia)
export async function verificarTagsNoDestino(
  id_config: string | undefined,
  tags: string[],
): Promise<string[]> {
  if (!tags.length) return [];
  const id = exigirConfig(id_config);
  const existentes: string[] = [];
  for (const lote of dividirEmLotes(tags, 5000)) {
    const { data } = await inovaone_api.post<{ existentes: string[] }>(
      `/impressao_config/${id}/destino_itens/tags`,
      { tags: lote },
    );
    existentes.push(...(data?.existentes ?? []));
  }
  return existentes;
}

// Cria os itens no destino em lotes; tag já existente volta em "existentes"
export async function criarItensNoDestino(
  id_config: string | undefined,
  itens: ItemInovaid[],
): Promise<RespostaCriarItensDestino> {
  const id = exigirConfig(id_config);
  const total: RespostaCriarItensDestino = {
    criados: [],
    existentes: [],
    recusados: [],
  };
  for (const lote of dividirEmLotes(itens, MAX_ITENS_POR_LOTE_INOVAID)) {
    const { data } = await inovaone_api.post<RespostaCriarItensDestino>(
      `/impressao_config/${id}/destino_itens/itens`,
      { itens: lote },
    );
    total.criados.push(...(data?.criados ?? []));
    total.existentes.push(...(data?.existentes ?? []));
    total.recusados.push(...(data?.recusados ?? []));
  }
  return total;
}

export type CategoriaInovaid = { _id: string; nome: string };

// Categorias da conta do iNOVAID dona do token (só com destino iNOVAID)
export async function listarCategoriasDoInovaid(
  id_config: string | undefined,
): Promise<CategoriaInovaid[]> {
  const id = exigirConfig(id_config);
  const { data } = await inovaone_api.get<{ categorias: CategoriaInovaid[] }>(
    `/impressao_config/${id}/destino_itens/categorias`,
  );
  return data?.categorias ?? [];
}
